import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faLock, faMailBulk, faPhone, faUnlock } from '@fortawesome/free-solid-svg-icons';
import userlogo from '../../../assets/images/user.png'
import Empty from '../../../assets/images/EmptyState.svg'
const List = ({ data }) => {

    return (
        <React.Fragment>
            <div className={`${styles['order-first']} col-md-9`}>
                <div className={`${styles['filter-card']} mb-3`}>
                    <div className="row">
                        <div className="col-md-6">
                            <div>
                                <label className={`${styles['label-ct']}`}>Show</label>
                                <select className="form-select d-inline-block w-auto mx-2">
                                    <option>20</option>
                                    <option>50</option>
                                    <option>100</option>
                                </select>
                                <span className={`${styles['label-ct']}`}>Records Per Page</span>
                            </div>
                        </div>
                        <div className="col-md-6 d-flex justify-content-end">
                            <div>
                                <button className="btn btn-outline-secondary btn-sm me-2" disabled>
                                    &lt; Previous
                                </button>
                                <div className="btn-group">
                                    <button className="btn btn-outline-primary btn-sm active">1</button>
                                    <button className="btn btn-outline-primary btn-sm">2</button>
                                    <button className="btn btn-outline-primary btn-sm">3</button>
                                </div>
                                <button className="btn btn-outline-secondary btn-sm ms-2">Next &gt;</button>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-4">
                            <div className='d-flex align-items-center'>
                                <input type="checkbox" id="selectAll" className="form-check-input me-2" />
                                <label htmlFor="selectAll" className={`${styles['label-ct']} me-4 mt-1`}>
                                    Select All
                                </label>
                            </div>
                        </div>
                        <div className="col-md-8 d-flex justify-content-end">
                            <div className={`${styles['w-30']}`}>
                                <button className={`${styles['edit-btn']} btn`}>
                                    Download Excel<FontAwesomeIcon icon={faDownload} className='ps-2' />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {data?.SEARCHED_LIST.map((item) => {
                    return (
                        <div className={`${styles['details-card']} card mb-3`}>
                            <div className="row">
                                <div className="col-md-6">
                                    <input type="checkbox" />
                                    <div className="d-flex">
                                        <div className={`${styles['userimg-icon']} me-3`}>
                                            <img src={item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/candidate/pic/${item.CANDIDATE_ID}/${item.PROFILE_IMAGE}` : userlogo} alt="profile" className="img-fluid" />
                                        </div>
                                        <div className={`${styles["profile-section"]}`}>
                                            <h5 className="mb-1">{item.CANDIDATE_NAME}</h5>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faPhone} />
                                                +91 XXXXXXXX
                                            </p>
                                            <p className="mb-1 d-flex align-items-center">
                                                <FontAwesomeIcon className={`${styles["icon-st"]} me-2`} icon={faMailBulk} />
                                                user@email.com
                                            </p>
                                        </div>
                                    </div>
                                    <button className={`${styles["search-btn"]} btn`}>
                                        Unlock full Profile <FontAwesomeIcon className="ps-2" icon={faLock} />
                                    </button>
                                    <hr />
                                    <div className="row mb-3">
                                        <div className={`${styles["profile-details"]}`}>
                                            {/* Profile Summary */}
                                            {item.PROFILE_SUMMARY && item.PROFILE_SUMMARY.length > 0 && (
                                                <p className="mb-1">
                                                    <strong>Profile Summary:</strong>{" "}
                                                    {item.PROFILE_SUMMARY.length > 100 ? (
                                                        <>
                                                            {item.PROFILE_SUMMARY.substring(0, 100)}...
                                                            <span className="text-primary ms-1">| Full Profile</span>
                                                        </>
                                                    ) : (
                                                        item.PROFILE_SUMMARY
                                                    )}
                                                </p>
                                            )}

                                            {/* Experience */}
                                            {(item.TOTAL_EXP_YEAR !== null && item.TOTAL_EXP_YEAR !== undefined) ||
                                                (item.TOTAL_EXP_MONTH !== null && item.TOTAL_EXP_MONTH !== undefined) ? (
                                                <p className="mb-1">
                                                    <strong>Experience:</strong>{" "}
                                                    {item.TOTAL_EXP_YEAR ? `${item.TOTAL_EXP_YEAR} Years` : ""}
                                                    {item.TOTAL_EXP_YEAR && item.TOTAL_EXP_MONTH ? " " : ""}
                                                    {item.TOTAL_EXP_MONTH ? `${item.TOTAL_EXP_MONTH} Months` : ""}
                                                </p>
                                            ) : null}

                                            {/* Salary */}
                                            {item.CTC && item.CTC > 0 && (
                                                <p className="mb-1">
                                                    <strong>Salary:</strong> ₹{item.CTC.toLocaleString()}
                                                </p>
                                            )}

                                            {/* Other Profile Details */}
                                            {item.EDUCATION && <p className="mb-1"><strong>Education:</strong> {item.EDUCATION}</p>}
                                            {item.INDUSTRY && <p className="mb-1"><strong>Industry:</strong> {item.INDUSTRY}</p>}
                                            {item.FUNCTIONAL_AREA && <p className="mb-1"><strong>Functional Area:</strong> {item.FUNCTIONAL_AREA}</p>}
                                            {item.CURRENT_LOCATION && <p className="mb-1"><strong>Location:</strong> {item.CURRENT_LOCATION}</p>}
                                        </div>

                                        <div className="col-12 text-start">
                                            <button className={`${styles["profile-btn"]} btn w-100`}>
                                                <FontAwesomeIcon className="pe-2 text-danger" icon={faUnlock} />
                                                1 Profile Unlock = 1 Database Credit
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Column */}
                                <div className={`${styles["profile-details"]} border-start col-md-6`}>
                                    {/* Current Designation */}
                                    {item.CURRENT_DESIGNATION && (
                                        <React.Fragment>
                                            <h6>Current/ Latest</h6>
                                            <p>
                                                {item.CURRENT_DESIGNATION}
                                                {item.CURRENT_COMPANY ? ` at ${item.CURRENT_COMPANY}` : ""}
                                            </p>
                                        </React.Fragment>
                                    )}

                                    {/* Education */}
                                    {item.EDUCATION && (
                                        <React.Fragment>
                                            <h6>Education</h6>
                                            <p>{item.EDUCATION}</p>
                                        </React.Fragment>
                                    )}

                                    {/* Preferred Location */}
                                    {Array.isArray(item.prefferedLocation) && item.prefferedLocation.length > 0 && (
                                        <React.Fragment>
                                            <h6>Preferred Location</h6>
                                            <p>{item.prefferedLocation.map((city) => city.CITY).join(", ")}</p>
                                        </React.Fragment>
                                    )}

                                    {/* Skills */}
                                    {Array.isArray(item.SKILL) && item.SKILL.length > 0 && (
                                        <React.Fragment>
                                            <h6>Skills</h6>
                                            <p>{item.SKILL.map((skill) => skill.SKILL).join(" | ")}</p>
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                })}
                {
                    data?.SEARCHED_LIST.length === 0 && (
                        <div className={`${styles['details-card']} card mb-3 d-flex justify-content-center align-items-center text-center`}>
                            <div className="row w-100 d-flex justify-content-center">
                                <div className="col-md-6 d-flex flex-column align-items-center">
                                    <img
                                        width={150}
                                        height={150}
                                        src={Empty}
                                        alt="No profiles found"
                                    />
                                    <h4 className="mb-1">No profiles found</h4>
                                    <p>Please modify your search and expand your search criteria.</p>
                                    <button className={`${styles["search-btn"]} btn w-50 mt-2 mb-5`}>
                                        Modify Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>

        </React.Fragment>

    )
}

export default List